(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29647],{

/***/ 82567:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resume",
      function () {
        return __webpack_require__(8188);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Resume": function() { return /* binding */ Resume; },
  "default": function() { return /* binding */ resume; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/EnvelopeIcon.js
var EnvelopeIcon = __webpack_require__(82123);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiGithub.js
var SiGithub = __webpack_require__(41416);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiLinkedin.js
var SiLinkedin = __webpack_require__(32159);
// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.esm.js
var index_esm = __webpack_require__(70231);
// EXTERNAL MODULE: ./components/image.tsx + 1 modules
var components_image = __webpack_require__(13195);
// EXTERNAL MODULE: ./components/link.tsx + 1 modules
var components_link = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/layout/header.desktop-nav.hover-effect.tsx + 1 modules
var header_desktop_nav_hover_effect = __webpack_require__(47222);
// EXTERNAL MODULE: ./components/resume/resume-mobile-footer.tsx + 1 modules
var resume_mobile_footer = __webpack_require__(57579);
// EXTERNAL MODULE: ./components/resume/resume-section.tsx + 11 modules
var resume_section = __webpack_require__(5028);
// EXTERNAL MODULE: ./components/resume/resume-section-data-sidebar.tsx
var resume_section_data_sidebar = __webpack_require__(11245);
// EXTERNAL MODULE: ./components/resume/resume-section-date-events.tsx
var resume_section_date_events = __webpack_require__(58312);
// EXTERNAL MODULE: ./components/resume/use-resume-section-in-view.tsx
var use_resume_section_in_view = __webpack_require__(5851);
// EXTERNAL MODULE: ./content/tech-stack.tsx + 22 modules
var tech_stack = __webpack_require__(21222);
;// CONCATENATED MODULE: ./content/cv.tsx


var CV = {
    name: "Lalit Kumawat",
    title: "Fullstack Engineer",
    primary_stack: [
        tech_stack/* TECH.typescript */.O.typescript,
        tech_stack/* TECH.react */.O.react,
        tech_stack/* TECH.nodejs */.O.nodejs,
        tech_stack/* TECH.tailwindcss */.O.tailwindcss,
        tech_stack/* TECH.nestjs */.O.nestjs, 
    ],
    address: "Madhya Pradesh, India",
    email: "lalitkumawat112@gmail.com",
    website: "https://lalitkumawat.vercel.app",
    mobile: {
        href: "tel:+91xxxxxxxxxx",
        number: "+91 xxx xxx xxxx"
    },
    intro: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "I am a passionate self-taught software developer seeking a new challenge. I specialize in front-end & serverless backend- development using Typescript, React.js, and Node.js. As an advocate for web performance, accessibility, I create amazing web applications to improve the internet. I love encountering hard-to-solve-problems and approach them with patience, determination, and relentless perseverance."
    }),
    eduction: [
        // {
        //   dateFrom: "1992-08-01",
        //   dateTo: "1996-08-01",
        //   city: "Mönchengladbach",
        //   country: "Germany",
        //   institution: "Primary School Gertraudenstraße",
        //   certificate: "Primary School Certificate",
        //   level: "School",
        //   type: [],
        // },
        // {
        //   dateFrom: "1996-08-01",
        //   dateTo: "2002-08-01",
        //   city: "Mönchengladbach",
        //   country: "Germany",
        //   institution: "Comprehensive School Espenstraße",
        //   certificate: "Secondary School Certificate",
        //   level: "School",
        //   type: [],
        // },
        {
            dateFrom: "2009-06-01",
            dateTo: "2020-04-01",
            city: "Mandsaur",
            country: "India",
            institution: "Saraswati Vidhya Mandir",
            certificate: "High School Certificate",
            level: "School",
            type: [
                "relevant"
            ]
        },
        // {
        //   dateFrom: "2008-01-01",
        //   dateTo: "2008-07-01",
        //   city: "Cape Town",
        //   country: "South Africa",
        //   institution: "International Hotel School",
        //   certificate: "Skills, Tasks and Result Training Certificate",
        //   level: "Higher Education",
        //   type: ["restaurant", "management"],
        // },
        // {
        //   dateFrom: "2009-07-01",
        //   dateTo: "2012-07-01",
        //   city: "Cape Town",
        //   country: "South Africa",
        //   institution: "International Hotel School",
        //   certificate: "Higher Diploma in Professional Cookery & Kitchen Management",
        //   level: "Higher Education",
        //   type: ["restaurant", "management"],
        // },
        /*{
      dateFrom: "2009-07-01",
      dateTo: "2012-07-01",
      city: "Cape Town",
      country: "South Africa",
      institution: "International Hotel School",
      certificate: "Higher Diploma in Food & Beverage Management",
      level: "Higher Education",
      type: ["restaurant", "management"],
    },
    {
      dateFrom: "2013-01-01",
      dateTo: "2013-07-01",
      city: "Cape Town",
      country: "South Africa",
      institution: "International Hotel School",
      certificate: "Higher Diploma in Hospitality Management",
      level: "Higher Education",
      type: ["restaurant", "management"],
    },*/ // {
        //   dateFrom: "2009-07-01",
        //   dateTo: "2013-07-01",
        //   city: "Cape Town",
        //   country: "South Africa",
        //   institution: "International Hotel School",
        //   certificate: (
        //     <div>
        //       <div>Higher Diploma in Hospitality Management,</div>
        //       <div>Higher Diploma in Food & Beverage Management, </div>
        //       <div>Higher Diploma in Professional Cookery & Kitchen Management</div>
        //     </div>
        //   ),
        //   level: "Higher Education",
        //   type: ["relevant", "management", "restaurant"],
        // },
        {
            dateFrom: "2020-06-01",
            dateTo: "2024-06-01",
            city: "Mandsaur",
            country: "Madhya Pradesh, India",
            institution: "Mandsaur University",
            certificate: "Bachelor's, Computer Science",
            level: "Higher Education",
            type: [
                "relevant",
                "web / tech dev"
            ]
        }, 
    ],
    experience: [
        {
            dateFrom: "2020-07-01",
            dateTo: "2020-12-31",
            city: "",
            country: "",
            company: "",
            title: "",
            description: "",
            type: [
                "web / tech dev",
                "relevant"
            ],
            responsibilities: [
                {
                    content: "Learned C Language.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned how operating system works.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                }, 
            ]
        },
        {
            dateFrom: "2021-01-01",
            dateTo: "2021-12-31",
            city: "",
            country: "",
            company: "",
            title: "",
            description: "",
            type: [
                "web / tech dev",
                "relevant"
            ],
            responsibilities: [
                {
                    content: "Learned how Data Structures & Algorithms works.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Created my first ever portfolio website and open-sourced it.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned Python, Java & Object oriented Programming.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned HTML, CSS, Javascript and ReactJS.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                }, 
            ]
        },
        {
            dateFrom: "2022-01-01",
            dateTo: "2022-12-31",
            city: "",
            country: "",
            company: "",
            title: "",
            description: "",
            type: [
                "web / tech dev",
                "relevant"
            ],
            responsibilities: [
                {
                    content: "Worked on awesome projects such as Livekar, MoneyTracker.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned how to create cross-platform apps using Flutter and Dart.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned Android Development, Firebase, SQL & Git/GitHub.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned how Database Management & Computer Networking works.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                }, 
            ]
        },
        {
            dateFrom: "2023-01-01",
            dateTo: "2023-12-31",
            city: "",
            country: "",
            company: "",
            title: "",
            description: "",
            type: [
                "web / tech dev",
                "relevant"
            ],
            responsibilities: [
                {
                    content: "Started Open Source Contribution Journey from million.js library.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Worked on awesome projects such as GetSetBooking, Promptopia.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned Typescript, NextJS, ReactJS, NodeJS, Express, MongoDB.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                }, 
            ]
        },
        {
            dateFrom: "2024-01-01",
            dateTo: "2024-02-01",
            city: "",
            country: "",
            company: "",
            title: "",
            description: "",
            type: [
                "web / tech dev",
                "relevant"
            ],
            responsibilities: [
                {
                    content: "Worked on awesome projects such as Real Time Chat, Omegle 2.0, Genius AI.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                },
                {
                    content: "Learned WebSocket, WebRTC, Docker, Prisma, PostgresQL, GraphQL, NestJS, Zustand.",
                    type: [
                        "web / tech dev",
                        "relevant"
                    ]
                }, 
            ]
        }, 
    ],
    capabilities: {
        languages: [
            {
                name: "Hindi - native",
                Icon: null
            },
            {
                name: "English - bilingual",
                Icon: null
            }, 
        ],
        programmingLanguages: [
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.html_5 */.O.html_5,
            tech_stack/* TECH.css_3 */.O.css_3,
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.python */.O.python,
            tech_stack/* TECH.sql */.O.sql,
            tech_stack/* TECH.php */.O.php, 
        ],
        librariesFrameworks: [
            tech_stack/* TECH.react */.O.react,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss,
            tech_stack/* TECH.nextjs */.O.nextjs,
            // TECH.trpc,
            tech_stack/* TECH.prisma */.O.prisma,
            tech_stack/* TECH.graphql */.O.graphql,
            tech_stack/* TECH.react_query */.O.react_query,
            tech_stack/* TECH.redux */.O.redux,
            tech_stack/* TECH.zustand */.O.zustand,
            // TECH.remix,
            tech_stack/* TECH.jest */.O.jest,
            // TECH.turborepo,
            tech_stack/* TECH.nodejs */.O.nodejs,
            tech_stack/* TECH.nestjs */.O.nestjs,
            tech_stack/* TECH.express */.O.express,
            tech_stack/* TECH.webpack */.O.webpack,
            tech_stack/* TECH.framer */.O.framer,
            tech_stack/* TECH.mongodb */.O.mongodb,
            tech_stack/* TECH.postgresql */.O.postgresql,
            tech_stack/* TECH.redis */.O.redis,
            tech_stack/* TECH.docker */.O.docker, 
        ],
        serviceProviders: [
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.aws */.O.aws,
            tech_stack/* TECH.firebase */.O.firebase,
            tech_stack/* TECH.github */.O.github
        ],
        marketing: [
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.aws */.O.aws,
            tech_stack/* TECH.firebase */.O.firebase,
            tech_stack/* TECH.netlify */.O.netlify,
            tech_stack/* TECH.planetscale */.O.planetscale,
            tech_stack/* TECH.github */.O.github, 
        ],
        dataProviders: [
            tech_stack/* TECH.wordpress */.O.wordpress
        ],
        tools: [
            tech_stack/* TECH.vscode */.O.vscode,
            tech_stack/* TECH.git */.O.git,
            tech_stack/* TECH.yarn */.O.yarn,
            tech_stack/* TECH.npm */.O.npm,
            tech_stack/* TECH.figma */.O.figma,
            tech_stack/* TECH.postman */.O.postman,
            tech_stack/* TECH.office */.O.office,
            tech_stack/* TECH.dev_tools */.O.dev_tools, 
        ]
    },
    certifications: [
        {
            date: "2021",
            name: "Oracle - Java Foundations Certification",
            type: [
                "web / tech dev",
                "relevant"
            ]
        },
        {
            date: "2021",
            name: "Cisco - C Foundations Certification",
            type: [
                "web / tech dev",
                "relevant"
            ]
        }, 
    ],
    coursework: [
        {
            name: "Data Structures & Algorithms"
        },
        {
            name: "Object Oriented Programming"
        },
        {
            name: "Operating Systems"
        },
        {
            name: "Database Management System"
        },
        {
            name: "Web & Networking Concepts"
        }, 
    ],
    // references: [
    //   {
    //     author: "Jeroen Hartgers",
    //     title: "Managing Director",
    //     company: "Kids Living",
    //     reference:
    //       "It is a pleasure to work with Felix as a design and development partner and ecommerce specialist. You can point out a problem to him and know that it will be handled, and he brings a positive vibe to the team at the same time. His approach to web is modern and progressive, and it is very refreshing. Furthermore, he has a real passion for web development, producing excellent results, being up to date with all the latest technology and being reliable and easy to work with. Ask him about anything from performance to accessibility or on-site tech support, he'll go out of his way to find a solution.",
    //   },
    //   {
    //     author: "Thomas Fuss",
    //     title: "Managing Director",
    //     company: "Ademas Solutions",
    //     reference:
    //       "Felix has a highly technical aptitude, which is further enhanced by his experience and general desire to be the best. My favorite thing about working with Felix is his ability to tell when a problem needs to be fixed right away and when a problem needs to be solved quickly. Whatever he does, he is always dedicated to doing an excellent job, and he makes the right engineering decisions for the project. In addition to learning new technologies at an exceptionally fast rate, he is often the first one to come to when a technical problem arises. In his role as a team player, Felix appears equally comfortable joining a project team and working directly on it, mentoring less experienced developers, or leading a project as a technical lead. Felix has always been a pleasant presence at customer meetings, as he is able to answer questions clearly and accurately, and he is not afraid to express his opinion on technical issues as well. I will miss working with Felix and will be confident in recommending him for any technical position in the future. He is well liked and highly respected by his colleagues from all areas of the business.",
    //   },
    //   {
    //     author: "Juan De Bruyn",
    //     title: "Restaurant Manager",
    //     company: "The Exchange Restaurant",
    //     reference: `I have been fortunate enough to be working both along & with Lalit Kumawat for the past 8 months. Felix has been an absolute light and strength in the team he runs. His approach to every challenge with a calm, firm & respectful attitude is something to be admired and to be learned by everyone. In spite of the challenges, this type of leadership makes a happy and productive work environment because it brings everyone together. I wish Felix all the best for his future endeavors. He is sure to make any challenge he takes on an absolute success.`,
    //   },
    // ],
    personal: "I post videos on YouTube and code on GitHub. I enjoy creating content, working out, reading, and research in my free time. Please feel free to contact me with any project ideas you may have. I hope you enjoy looking through my portfolio, and I look forward to the chance to work with you on your next projects. Let us create amazing things! It is also important to me to keep up with web technology and UX design developments by listening to podcasts, attending local events, attending conferences, and using Twitter."
};

;// CONCATENATED MODULE: ./public/images/about/lalit-resume-profile2.png
/* harmony default export */ var lalit_resume_profile2 = ({"src":"/_next/static/media/lalit-resume-profile2.de72f202.png","height":612,"width":459,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAY1BMVEXf6ebX7e48geJ0mc/nxLO9lHrel3Xu9ff7//3My8xqoe7B3Ofl8PTe7vRRUz9uVEdBJhiosa6ou7dkbGfmq3spc8/G3O9WjeJFedCElbd+trHCu6wRRprDpJZeebAlUapHZ6ePKhupAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAOUlEQVR4nAXBhQHAIBAAsUMfqzvV/adsQpBxkIYQu35SEN3cVgrWnxnBehSrud2R0do878eS0rZfPzn2AlqKaudxAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(54096);
// EXTERNAL MODULE: ./utils/scroll-to.tsx
var scroll_to = __webpack_require__(76811);
;// CONCATENATED MODULE: ./pages/resume.tsx



















var Resume = function(props) {
    var ref = (0,use_resume_section_in_view/* useResumeSectionInView */.l)(), sections = ref.sections, filter = ref.filter, showSection = ref.showSection, selectFilter = ref.selectFilter;
    var ref1 = (0,react.useState)("intro"), inView = ref1[0], setInView = ref1[1];
    (0,react.useEffect)(function() {
        for(var key in sections){
            var val = sections[key];
            if (!val.showing) continue;
            if (val.centerVisible && val.fullyVisible) {
                setInView(key);
                break;
            }
            if (val.fullyVisible) {
                setInView(key);
                break;
            }
            if (val.centerVisible) {
                setInView(key);
                break;
            }
            setInView("");
        }
    }, [
        sections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: "margin-0 padding-0 relative block min-h-screen appearance-none border-none text-gray-900 print:!table [&_td]:p-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                className: " hidden w-full print:!table-header-group",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                        className: "flex w-[1024px] pb-4 text-left font-normal",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-4xl font-extrabold tracking-tight",
                                        children: CV.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "flex gap-1 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-semibold tracking-tight text-gray-500",
                                                children: [
                                                    CV.title,
                                                    " -",
                                                    " "
                                                ]
                                            }),
                                            CV.primary_stack.map(function(param) {
                                                var name = param.name, Icon = param.Icon;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "mx-1 flex items-center gap-1 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                            className: "h-4 w-4"
                                                        }),
                                                        name
                                                    ]
                                                }, name);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-auto mt-1 mt-auto flex-1 items-end justify-end text-right text-[15px] text-gray-500 spacing-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                href: "tel:".concat(CV.mobile.href),
                                                children: CV.mobile.number
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: " - "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                href: "mailto:".concat(CV.email),
                                                children: CV.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                href: CV.website,
                                                children: CV.website.replace("https://", "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: " - "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                href: "https://github.com/lalitkumawat1m",
                                                children: "github.com/lalitkumawat1m"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                className: "fixed inset-x-0 bottom-0 hidden w-full text-center print:!table-footer-group",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                            className: "absolute bottom-0 left-1/2 -translate-x-1/2 pb-1 pt-3 text-[13px] font-medium tracking-tight text-gray-400",
                            children: [
                                "View full resume at",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    href: "https://lalit.dev",
                                    children: "www.lalitdev"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                className: "block print:table-row-group print:!h-screen print:!min-h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    className: "block print:!table-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "block print:!table-cell",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "relative mx-auto mb-16 grid max-w-6xl gap-12 px-4 py-16 print:!flex print:!py-0 print:!pl-24 md:px-8 lg:grid-cols-[1fr_200px] print:[&_*]:![-webkit-print-color-adjust:exact] print:[&_*]:![color-adjust:exact] print:[&_*]:![print-color-adjust:exact]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                    className: "snap-y snap-normal spacing-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section/* ResumeSection */.o, {
                                            title: "Intro",
                                            className: "break-inside-avoid print:!max-w-3xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[15px] leading-relaxed text-gray-500 d:text-gray-300 print:!-ml-24 print:!max-w-3xl print:!text-base",
                                                children: CV.intro
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            className: "relative -top-2 z-10 ml-2 hidden h-56 w-44 rotate-6 bg-white print:!absolute print:!right-2 print:!top-8 print:!mt-0 print:!inline-block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-x-10 top-0 h-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-y-10 right-0 w-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_top,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-x-10 bottom-0 h-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-y-10 left-0 w-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_top,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute bottom-full right-0 -mb-px flex h-8 items-end overflow-hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "-mb-px flex h-[2px] w-44 -scale-x-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute left-2 top-[calc(100%-1px)] -mb-px flex h-8 items-start overflow-hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "-mt-px flex h-[2px] w-44 -scale-x-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex h-full items-center justify-center px-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                                        src: lalit_resume_profile2,
                                                        preload: true,
                                                        className: "rounded-sm shadow-xl shadow-sky-400/10",
                                                        alt: "Lalit Kumawat Profile Pic",
                                                        width: "176",
                                                        height: "224",
                                                        pixelDensity: 2
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section/* ResumeSection */.o, {
                                            title: "Experience",
                                            className: (0,clsx_m/* default */.Z)(!CV.experience.filter(function(param) {
                                                var type = param.type;
                                                return type.includes(filter) || filter === "all";
                                            }).length && "!hidden"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "spacing-8",
                                                children: CV.experience.sort(function(a, b) {
                                                    if (new Date(a.dateFrom) < new Date(b.dateFrom)) return 1;
                                                    if (new Date(a.dateFrom) > new Date(b.dateFrom)) return -1;
                                                    return 0;
                                                }).filter(function(param) {
                                                    var type = param.type;
                                                    return type.includes(filter) || filter === "all";
                                                }).map(function(param, index, arr) {
                                                    var dateFrom = param.dateFrom, dateTo = param.dateTo, city = param.city, country = param.country, title = param.title, responsibilities = param.responsibilities, company = param.company, description = param.description, type = param.type;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                        className: "relative mb-auto break-inside-avoid-page",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "relative flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section_data_sidebar/* ResumeSectionDateSidebar */.E, {
                                                                    dateFrom: dateFrom,
                                                                    dateTo: dateTo,
                                                                    showDateRange: true,
                                                                    isLast: index === arr.length - 1
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section_date_events/* ResumeSectionDateEvents */.h, {
                                                                    name: title,
                                                                    organization: company,
                                                                    city: city,
                                                                    country: country,
                                                                    dateFrom: dateFrom,
                                                                    dateTo: dateTo,
                                                                    showDateRange: true,
                                                                    description: description,
                                                                    responsibilities: responsibilities
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section/* ResumeSection */.o, {
                                            className: (0,clsx_m/* default */.Z)("break-inside-avoid", !CV.eduction.filter(function(param) {
                                                var type = param.type;
                                                return type.includes(filter) || filter === "all";
                                            }).length && "!hidden"),
                                            title: "Education",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "spacing-8",
                                                children: CV.eduction.sort(function(a, b) {
                                                    if (new Date(a.dateFrom) < new Date(b.dateFrom)) return 1;
                                                    if (new Date(a.dateFrom) > new Date(b.dateFrom)) return -1;
                                                    return 0;
                                                }).filter(function(param) {
                                                    var type = param.type;
                                                    return type.includes(filter) || filter === "all";
                                                }).map(function(param, index, arr) {
                                                    var dateFrom = param.dateFrom, dateTo = param.dateTo, city = param.city, country = param.country, institution = param.institution, certificate = param.certificate, level = param.level;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section_data_sidebar/* ResumeSectionDateSidebar */.E, {
                                                                dateFrom: dateFrom,
                                                                dateTo: dateTo,
                                                                showDateRange: false,
                                                                isLast: index === arr.length - 1
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section_date_events/* ResumeSectionDateEvents */.h, {
                                                                name: certificate,
                                                                organization: institution,
                                                                city: city,
                                                                country: country,
                                                                dateFrom: dateFrom,
                                                                dateTo: dateTo,
                                                                showDateRange: false,
                                                                description: "",
                                                                responsibilities: []
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section/* ResumeSection */.o, {
                                            className: "break-inside-avoid",
                                            title: "Capabilities",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "spacing-8 print:!-ml-24 print:!spacing-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                    children: "Languages"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.languages.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                    children: "Programming Languages"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.programmingLanguages.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                    children: "Libraries & Frameworks"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.librariesFrameworks.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                        children: "Service Providers"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.serviceProviders.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                        children: "Content Platforms"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.dataProviders.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1 print:!grid print:!max-w-3xl print:!grid-cols-[140px_1fr]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        className: "text-[17px] font-bold text-gray-900 d:text-gray-100 print:!text-sm print:!font-semibold ",
                                                                        children: "Tools"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600 print:!mt-0",
                                                                children: CV.capabilities.tools.map(function(language, index) {
                                                                    return language.name;
                                                                }).join(", ")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_section/* ResumeSection */.o, {
                                            className: (0,clsx_m/* default */.Z)("break-inside-avoid", !CV.certifications.filter(function(param) {
                                                var type = param.type;
                                                return type.includes(filter) || filter === "all";
                                            }).length && "!hidden"),
                                            title: "Certifications",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "spacing-6 print:!-ml-24",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600",
                                                            children: CV.certifications.sort(function(a, b) {
                                                                if (new Date(a.date) < new Date(b.date)) return 1;
                                                                if (new Date(a.date) > new Date(b.date)) return -1;
                                                                return 0;
                                                            }).filter(function(param) {
                                                                var type = param.type;
                                                                return type.includes(filter) || filter === "all";
                                                            }).map(function(param, index, arr) {
                                                                var date = param.date, name = param.name, type = param.type;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "inline-flex items-baseline gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-xs font-medium leading-[16px] text-gray-400 d:text-gray-500 print:!text-sm",
                                                                                children: date
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "select-none text-sm text-gray-300 print:!text-gray-500",
                                                                                children: "-"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "print:!text-base",
                                                                                children: name
                                                                            })
                                                                        ]
                                                                    })
                                                                }, index);
                                                            })
                                                        })
                                                    }),
                                                    [
                                                        "all",
                                                        "relevant",
                                                        "web / tech dev"
                                                    ].includes(filter) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "relative max-w-prose spacing-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                className: "items-baseline text-sm tracking-tight spacing-1 ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        className: "text-[17px] font-bold text-gray-900 d:text-gray-100",
                                                                        children: "Coursework"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "list-outside list-disc pl-4 text-sm text-gray-500 marker:text-gray-400 d:text-gray-300/80 d:marker:text-gray-600",
                                                                children: CV.coursework.map(function(param, index) {
                                                                    var name = param.name;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: "pl-3",
                                                                        children: name
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(resume_section/* ResumeSection */.o, {
                                            title: "Interests",
                                            className: "break-inside-avoid",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[15px] leading-relaxed text-gray-500 d:text-gray-300 print:!-ml-24 print:!text-base",
                                                    children: CV.personal
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-24"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                    className: "top-[144px] mb-auto hidden max-h-min print:!hidden lg:sticky lg:spacing-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                            className: "relative -top-2 z-0 ml-2 h-48 w-[9.5rem] rotate-6 print:!absolute print:!left-40 print:!top-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-x-10 top-0 h-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-y-10 right-0 w-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_top,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-x-10 bottom-0 h-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -inset-y-10 left-0 w-0.5 bg-gray-900/[0.1] [mask-image:linear-gradient(to_top,transparent,white_4rem,white_calc(100%-4rem),transparent)] d:bg-gray-50/20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute bottom-full right-0 -mb-px flex h-8 items-end overflow-hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "-mb-px flex h-[2px] w-44 -scale-x-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute left-2 top-[calc(100%-1px)] -mb-px flex h-8 items-start overflow-hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "-mt-px flex h-[2px] w-44 -scale-x-100",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(56,189,248,0)_0%,#0EA5E9_32.29%,rgba(236,72,153,0.3)_67.19%,rgba(236,72,153,0)_100%)]"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex h-full items-center justify-center px-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                                        src: lalit_resume_profile2,
                                                        preload: true,
                                                        className: "rounded-sm shadow-xl shadow-sky-400/10",
                                                        alt: "Lalit Kumawat Profile Pic",
                                                        width: "176",
                                                        height: "224",
                                                        pixelDensity: 2
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "spacing-6 print:!hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                                className: "relative whitespace-nowrap text-[15px] font-medium text-gray-300 spacing-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_desktop_nav_hover_effect/* HoverEffect */.d, {
                                                        className: "border-none border-transparent bg-gray-100"
                                                    }),
                                                    Object.keys(sections).map(function(key) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                                            className: (0,clsx_m/* default */.Z)("-ml-2 w-min rounded-md px-2 py-1 outline-none transition-all duration-75 hfa:outline-none", inView === key ? "text-sky-500 hf:text-sky-600" : "hf:text-gray-700"),
                                                            onClick: function() {
                                                                return showSection(key);
                                                            },
                                                            href: "#".concat(key),
                                                            children: (0,capitalize/* capitalize */.k)(key)
                                                        }, key);
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "spacing-2 print:!hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-[13px] font-medium text-gray-700 d:text-gray-300",
                                                    children: "Filter view:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    className: "flex flex-wrap gap-1.5",
                                                    children: [
                                                        "all",
                                                        "relevant",
                                                        "web / tech dev"
                                                    ].map(function(type) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            className: (0,clsx_m/* default */.Z)("rounded border  px-1.5 py-0.5 text-xs font-medium outline-none hfa:outline-none ", filter.includes(type) ? "border-sky-300 bg-sky-100 text-gray-700 hf:border-sky-400 hf:bg-sky-300/40 hf:text-gray-800 d:border-sky-700 d:bg-sky-900/60 d:text-gray-200 d:hf:bg-sky-700/50 d:hf:text-gray-100" : "border-gray-200 bg-gray-100 text-gray-400 hf:border-gray-300 hf:bg-gray-200 hf:text-gray-700 d:border-gray-700 d:bg-gray-800 d:text-gray-300 d:hf:border-gray-600 d:hf:bg-gray-700 d:hf:text-gray-100"),
                                                            onClick: function() {
                                                                selectFilter(type);
                                                                (0,scroll_to/* scrollToY */.d)(150, 0);
                                                            },
                                                            children: type
                                                        }, type);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "mt-2 spacing-1 print:!hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                                    className: "flex flex-wrap gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                                            href: "mailto:lalitkumawat1129@gmail.com",
                                                            target: "_blank",
                                                            className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                                            "data-tip": "lalitkumawat1129@gmail.com",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Email me"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvelopeIcon/* default */.Z, {
                                                                    className: "h-4 w-4"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                                            href: "https://github.com/lalitkumawat1m",
                                                            target: "_blank",
                                                            "data-tip": "Github",
                                                            className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Github"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SiGithub/* SiGithub */.p, {
                                                                    className: "h-4 w-4"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                                            href: "https://twitter.com/lalitkumawat1m",
                                                            target: "_blank",
                                                            "data-tip": "Twitter",
                                                            className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Twitter"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaXTwitter */.LCd, {
                                                                    className: "h-4 w-4"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                                            href: "https://www.linkedin.com/in/lalitkumawat1m",
                                                            target: "_blank",
                                                            "data-tip": "LinkedIn",
                                                            className: "rounded p-1 text-gray-400 transition-all duration-75 hf:bg-gray-100 hf:text-gray-700 d:text-gray-300 d:hf:bg-gray-800/80 d:hf:text-gray-200",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "LinkedIn"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SiLinkedin/* SiLinkedin */.n, {
                                                                    className: "h-4 w-4"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "ml-1 text-[13px] text-gray-500 d:text-gray-400",
                                                    children: "Madhya Pradesh, India"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(resume_mobile_footer/* ResumeFooter */.U, {})
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var resume = (Resume);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [93415,49526,93565,48368,49774,92888,40179], function() { return __webpack_exec__(82567); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);